import { configureStore } from "@reduxjs/toolkit";
//  IMPLEMENTATION REDUX PERSIST

import storage from "redux-persist/lib/storage";
import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import thunk from "redux-thunk";
import ReduxUser from "./ReduxUser";
import ReduxInstance from "./ReduxInstance";
import ReduxToken from "./ReduxToken";
import ReduxFilter from "./ReduxFilter";
import ReduxToggle from "./ReduxToggle";
import ReduxRefresh from "./ReduxRefresh";

const reducers = combineReducers({
  ReduxUser: ReduxUser,
  ReduxInstance: ReduxInstance,
  ReduxToken: ReduxToken,
  ReduxFilter: ReduxFilter,
  ReduxToggle: ReduxToggle,
  ReduxRefresh: ReduxRefresh,
});

const persistConfig = {
  key: "easygouv",
  storage,
  blacklist: ["ReduxToken", "ReduxFilter", "ReduxToggle", "ReduxRefresh"],
  // whitelist: [""],
};

const persistedReducer = persistReducer(persistConfig, reducers);

export const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== "production",
  middleware: [thunk],
});

// export const store = configureStore({
//   reducer: { ReduxUser: ReduxUser, ReduxInstance: ReduxInstance },
// });
